const AuthRoutes = {
    path: '/',
    component: () => import('@/layouts/blank/BlankLayout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        { name: 'public_ohs_report', path: '/site/:code/report', component: () => import('@/views/pages/OHS/Site/PublicSite.vue'), meta: { title: 'Report an issue', requiresAuth: false } },
        {
            name: 'public_ohs_swms',
            path: '/site/:code/swms/:id',
            component: () => import('@/views/pages/OHS/Site/PublicSite.vue'),
            meta: { title: 'Sign SWMS', requiresAuth: false }
        },
        {
            name: 'public_ohs_paperwork',
            path: '/paperwork/:token',
            component: () => import('@/views/pages/OHS/Supplier/PublicPaperwork.vue'),
            meta: { title: 'Supplier paperwork', requiresAuth: false }
        },
        {
            name: 'public_ohs_site',
            path: '/site/:code',
            component: () => import('@/views/pages/OHS/Site/PublicSite.vue'),
            meta: { title: 'Site safety', requiresAuth: false }
        },
        // {
        //     name: 'Landing Page',
        //     path: '/',
        //     component: () => import('@/views/pages/landingpage/index.vue')
        // },

        // {
        //     name: 'Side Login',
        //     path: '/auth/login',
        //     component: () => import('@/views/authentication/SideLogin.vue')
        // },
        {
            // Where the provider lands after the API resolves the identity. It
            // carries a one-time code, which this view swaps for a real token.
            name: 'social_callback',
            path: '/auth/social',
            component: () => import('@/views/pages/Authentication/SocialCallback.vue'),
            meta: {
                title: 'Signing in',
                requiresAuth: false
            }
        },

        {
            // Where the provider lands when the attempt began at Account
            // settings rather than the login screen. It carries a ticket for an
            // identity the API has verified but deliberately not resolved to an
            // account -- this view redeems it on an authenticated request.
            //
            // requiresAuth stays false even though redeeming needs a session:
            // the guard's answer to a missing one is a redirect that discards
            // the ticket, so the view checks for itself and can say what
            // actually happened.
            name: 'social_link',
            path: '/auth/social/link',
            component: () => import('@/views/pages/Authentication/SocialLink.vue'),
            meta: {
                title: 'Connecting',
                requiresAuth: false
            }
        },

        {
            name: 'login',
            path: '/login',
            component: () => import('@/views/pages/Authentication/SideLogin.vue'),
            meta: {
                title: 'Login',
                requiresAuth: false
            }
        },

        // {
        //     name: 'register',
        //     path: '/register',
        //     component: () => import('@/views/pages/Authentication/SideRegister.vue'),
        //     meta: {
        //         title: 'Register',
        //         requiresAuth: false
        //     }
        // },
        {
            name: 'register',
            path: '/register',
            component: () => import('@/views/pages/Authentication/SideRegister.vue'),
            meta: {
                title: 'Register',
                requiresAuth: false
            }
        },
        {
            name: 'register_complete',
            path: '/register-complete',
            component: () => import('@/views/pages/Authentication/BoxedRegisterComplete.vue'),
            meta: {
                title: 'Register Complete',
                requiresAuth: false
            }
        },
        {
            name: 'register_cancel',
            path: '/register-cancelled',
            component: () => import('@/views/pages/Authentication/BoxedRegisterCancel.vue'),
            meta: {
                title: 'Register Cancel',
                requiresAuth: false
            }
        },
        {
            name: 'verify_email?verification=:token',
            path: '/verification-email',
            component: () => import('@/views/pages/Authentication/BoxedVerification.vue'),
            meta: {
                title: 'Register',
                requiresAuth: false
            }
        },
        {
            // Code-entry verification page. Reached after free-plan signup
            // (?email=...) or after Stripe checkout success (?session_id=...).
            name: 'verify_email_code',
            path: '/verify-email',
            component: () => import('@/views/pages/Authentication/BoxedVerifyEmail.vue'),
            meta: {
                title: 'Verify Email',
                requiresAuth: false
            }
        },

        // {
        //     name: 'Side Forgot Password',
        //     path: '/auth/forgot-password',
        //     component: () => import('@/views/authentication/SideForgotPassword.vue')
        // },
        {
            name: 'forgot_password',
            path: '/forgot-password',
            component: () => import('@/views/pages/Authentication/BoxedForgotPassword.vue'),
            meta: {
                title: 'Forgot Password',
                requiresAuth: false
            }
        },
        {
            name: 'reset_password?password=:token',
            path: '/reset-password',
            component: () => import('@/views/pages/Authentication/BoxedResetPassword.vue'),
            meta: {
                title: 'Reset Password',
                requiresAuth: false
            }
        },
        {
            name: 'invitation_link?invitelink=:token',
            path: '/invitation-link',
            component: () => import('@/views/pages/Authentication/BoxInvitationLink.vue'),
            meta: {
                title: 'Invitation Link',
                requiresAuth: false
            }
        },
        {
            name: 'invitationsub_link?invitelink=:token',
            path: '/invitation-sub-link',
            component: () => import('@/views/pages/Authentication/BoxInvitationSubLink.vue'),
            meta: {
                title: 'Invitation Link',
                requiresAuth: false
            }
        },

        // {
        //     name: 'Side Two Steps',
        //     path: '/auth/two-step',
        //     component: () => import('@/views/authentication/SideTwoStep.vue')
        // },
        {
            name: 'two_factor',
            path: '/two-step',
            component: () => import('@/views/pages/Authentication/SideTwoStep.vue'),
            meta: {
                title: 'Two Factor Authentication',
                requiresAuth: false
            }
        },

        // {
        //     name: 'error',
        //     path: '/404',
        //     component: () => import('@/views/authentication/Error.vue'),
        //     meta: {
        //         title: 'Error 404',
        //         requiresAuth: false
        //     }
        // },
        {
            name: 'maintenance',
            path: '/maintenance',
            component: () => import('@/views/pages/Authentication/Maintenance.vue'),
            meta: {
                title: 'Under Maintenance',
                requiresAuth: false
            }
        },
        {
            name: 'google_callback',
            path: '/auth/google/callback',
            component: () => import('@/views/auth/GoogleCallback.vue'),
            meta: {
                title: 'Google Authentication',
                requiresAuth: false
            }
        },
        {
            name: 'dropbox_callback',
            path: '/auth/dropbox/callback',
            component: () => import('@/views/auth/DropboxCallback.vue'),
            meta: {
                title: 'Dropbox Authentication',
                requiresAuth: false
            }
        },
        {
            name: 'onedrive_callback',
            path: '/auth/onedrive/callback',
            component: () => import('@/views/auth/OneDriveCallback.vue'),
            meta: {
                title: 'OneDrive Authentication',
                requiresAuth: false
            }
        },
        {
            name: 'test_form',
            path: '/test-form',
            component: () => import('@/views/pages/TestForm/index.vue'),
            meta: {
                title: 'Test Form',
                requiresAuth: false
            }
        },
        // Printed-QR plan viewer — public, token-only. Lives on the app's own
        // origin so the QR never exposes the API host or a storage path.
        {
            name: 'public_plan',
            path: '/p/:token',
            component: () => import('@/views/pages/FileManager/PublicPlanView.vue'),
            meta: {
                title: 'View Document',
                requiresAuth: false
            }
        },
        {
            name: 'public_folder',
            path: '/f/:token',
            component: () => import('@/views/pages/FileManager/PublicFolderView.vue'),
            meta: {
                title: 'Shared Folder',
                requiresAuth: false
            }
        },
        // Client Access Portal - Public document viewing/signing
        {
            name: 'client_document',
            path: '/document/:code',
            component: () => import('@/views/pages/ClientPortal/ClientAccessPortal.vue'),
            meta: {
                title: 'View Document',
                requiresAuth: false
            }
        },
        // Contract Signing Portal - Public contract signing
        {
            name: 'sign_contract',
            path: '/sign-contract/:jobId/:token',
            component: () => import('@/views/pages/ClientPortal/ContractSigning.vue'),
            meta: {
                title: 'Sign Contract',
                requiresAuth: false
            }
        },
        // Public SWMS view + sign
        {
            name: 'public_swms',
            path: '/swms/:code',
            component: () => import('@/views/pages/OHS/PublicSwms.vue'),
            meta: {
                title: 'Safe Work Method Statement',
                requiresAuth: false
            }
        }
    ]
};

export default AuthRoutes;
